import constant from '../_config/constant'
import { logoutBrowserSession } from '../_lib/browserSession'

export async function logout() {
    try {
        await logoutBrowserSession()
    } finally {
        localStorage.removeItem(constant.TEMP_REF)
    }
}
